export function SmallCross() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M12.071 13.485L9.95 15.607a1 1 0 01-1.414-1.415l2.12-2.12-2.12-2.122A1 1 0 019.95 8.536l2.121 2.12 2.121-2.12a1 1 0 111.415 1.414l-2.122 2.121 2.122 2.121a1 1 0 01-1.415 1.415l-2.12-2.122z" fill="currentColor"></path>
    </svg>
  );
}
